<ng-template #t let-fill="fill">
  <span class="star" [class.full]="fill === 100">
    <span class="half" [style.width.%]="fill"><mat-icon>star</mat-icon></span><mat-icon>star</mat-icon>
  </span>
</ng-template>

<div class="d-flex flex-row gap-1 align-items-center" style="position: relative">
<ngb-rating [(rate)]="currentRate" [starTemplate]="t" [readonly]="true" [max]="5"></ngb-rating>
<div class="content">{{currentRate}}</div>
<div class="content sec">({{currentNumberOfReviews}})</div>
</div>

<!-- <button class="btn btn-sm btn-outline-primary mr-2" (click)="currentRate = 1.35">1.35</button>
<button class="btn btn-sm btn-outline-primary mr-2" (click)="currentRate = 4.72">4.72</button> -->

